import { z } from 'zod';
/**
 * Canonical error payload. Shape matches the Fastify response interceptor
 * in `marketplace-api/src/plugins/envelope.ts`.
 */
export const errorSchema = z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
});
/**
 * Discriminated-union envelope wrapping every successful / failed response.
 * Generic over the `data` schema so callers retain strong typing.
 */
export const envelopeSchema = (data) => z.discriminatedUnion('success', [
    z.object({ success: z.literal(true), data }),
    z.object({ success: z.literal(false), error: errorSchema }),
]);
//# sourceMappingURL=envelope.js.map